import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'assistantNames'})
export class AssistantNamesPipe implements PipeTransform {
  transform(value: any, ): any {
    console.log(value);

      switch (value) {
        case "default":
          return "Mike";
        case "nachbarbrief":
          return "Nachbarbrief";
        case "alternativsuche":
          return "Alternativsuche"
        case "bewertungsbrief":
          return "Bewertungsbrief"
        default:
          return "KI Assistent"
      }
  }
}
